import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationComponent } from './pages/authentication/authentication.component';
import { AuthenticationGuard } from './guards/authentication.guard';
import { TokenGuard } from './guards/token.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { CustomerDetailComponent } from './pages/customers/customer-detail/customer-detail.component';
import { PackageListComponent } from './pages/packages/package-list/package-list.component';
import { PackageEditorComponent } from './pages/packages/package-editor/package-editor.component';
import { ImportTypesComponent } from './pages/import-types/import-types.component';
import { ImportTypesDetailComponent } from './pages/import-types/import-types-detail/import-types-detail.component';
import { ImportsDetailComponent } from './pages/imports/imports-detail/imports-detail.component';
import { ImportLogsComponent } from './pages/import-logs/import-logs.component';
import { ImportLogsDetailComponent } from './pages/import-logs/import-logs-detail/import-logs-detail.component';
import { ImportEditComponent } from './pages/imports/import-edit/import-edit.component';
import { ImportConnectionComponent } from './pages/imports/import-connection/import-connection.component';
import { CompositionsComponent } from './pages/compositions/compositions.component';
import { CompositionDetailComponent } from './pages/compositions/composition-detail/composition-detail.component';
import { CompositionWizardComponent } from './pages/compositions/composition-wizard/composition-wizard.component';
import { CompositionAppEditorComponent } from './pages/compositions/composition-app-editor/composition-app-editor.component';
import { CompositionAppDetailComponent } from './pages/compositions/composition-app-detail/composition-app-detail.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageNotAuthComponent } from './pages/page-not-auth/page-not-auth.component';
import { ImportTypesEditComponent } from './pages/import-types/import-types-edit/import-types-edit.component';
import { ScreenDetailComponent } from './pages/screens/screen-detail/screen-detail.component';
import { ScreenSettingsComponent } from './pages/screen-settings/screen-settings.component';
import { ScreenListComponent } from './pages/screens/screen-list/screen-list.component';
import { ErrorlogComponent } from './pages/errorlog/errorlog.component';
import { KueComponent } from './pages/kue/kue.component';
import { FailedImportsComponent } from './pages/failed-imports/failed-imports.component';
import { FailedPackagesComponent } from './pages/failed-packages/failed-packages.component';
import { ImporterMonitorComponent } from './pages/importer-monitor/importer-monitor.component';
import { RedirectsComponent } from './pages/redirects/redirects.component';
import { RedirectDetailComponent } from './pages/redirects/redirect-detail/redirect-detail.component';
import { RedirectEditComponent } from './pages/redirects/redirect-edit/redirect-edit.component';
import { ImportCreateComponent } from './pages/imports/import-create/import-create.component';
import { RedirectLogComponent } from './pages/redirects/redirect-log/redirect-log.component';
import { ImportTypesCreateComponent } from './pages/import-types/import-types-create/import-types-create.component';
import { CodeSnippetsComponent } from './pages/code-snippets/code-snippets.component';
import { CodeSnippetsDetailComponent } from './pages/code-snippets/code-snippets-detail/code-snippets-detail.component';
import { CodeSnippetsEditComponent } from './pages/code-snippets/code-snippets-edit/code-snippets-edit.component';
import { LegacyCompositionComponent } from './pages/legacy-composition/legacy-composition.component';
import { LoginComponent } from './pages/authentication/login/login.component';
import { RegisterComponent } from './pages/authentication/register/register.component';
import { ResetComponent } from './pages/authentication/reset/reset.component';
import { MessageComponent } from './pages/authentication/message/message.component';
import { OrganisationsComponent } from './pages/organisations/organisations.component';
import { OrganisationDetailComponent } from './pages/organisations/organisation-detail/organisation-detail.component';
import { OrganisationEditComponent } from './pages/organisations/organisation-edit/organisation-edit.component';
import { PrivilegesComponent } from './pages/privileges/privileges.component';
import { PrivilegeEditComponent } from './pages/privileges/privilege-edit/privilege-edit.component';
import { RolesComponent } from './pages/roles/roles.component';
import { RoleEditComponent } from './pages/roles/role-edit/role-edit.component';
import { ProfileEditComponent } from './pages/profiles/profile-edit/profile-edit.component';
import { LegacyCompositionEditComponent } from './pages/legacy-composition/legacy-composition-edit/legacy-composition-edit.component';
import { LegacyCompositionDetailComponent } from './pages/legacy-composition/legacy-composition-detail/legacy-composition-detail.component';
import { ProfileDetailComponent } from './pages/profiles/profile-detail/profile-detail.component';
import { RoleDetailComponent } from './pages/roles/role-detail/role-detail.component';
import { ProfilesComponent } from './pages/profiles/profiles.component';
import { OrganisationSelectorComponent } from './pages/organisation-selector/organisation-selector.component';
import { GroupsComponent } from './pages/groups/groups.component';
import { GroupEditComponent } from './pages/groups/group-edit/group-edit.component';
import { GroupDetailComponent } from './pages/groups/group-detail/group-detail.component';
import { GroupRolesManagerComponent } from './pages/groups/group-roles-manager/group-roles-manager.component';
import { GroupParticipantsManagerComponent } from './pages/groups/group-participants-manager/group-participants-manager.component';
import { GroupContentManagerComponent } from './pages/groups/group-content-manager/group-content-manager.component';
import { OrganisationGuard } from './guards/organisation.guard';
import { SelectOrganisationComponent } from './pages/select-organisation/select-organisation.component';
import { CustomerEditComponent } from './pages/customers/customer-edit/customer-edit.component';
import { ScreenSettingsEditComponent } from './pages/screen-settings/screen-settings-edit/screen-settings-edit.component';
import { JsonEditComponent } from './pages/jsons/json-edit/json-edit.component';
import { JsonReadOnlyComponent } from './pages/jsons/json-read-only/json-read-only.component';
import { PrivilegeGuard } from './guards/privilege.guard';
import { PackagesComponent } from './pages/packages/packages/packages.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { FrontendErrorlogComponent } from './pages/frontend-errorlog/frontend-errorlog.component';
import { FrontendErrorlogDetailComponent } from './pages/frontend-errorlog/frontend-errorlog-detail/frontend-errorlog-detail.component';
import { ErrorlogDetailComponent } from './pages/errorlog/errorlog-detail/errorlog-detail.component';
import { DynamicContentComponent } from './pages/dynamic-content/dynamic-content.component';
import { DynamicContentEditComponent } from './pages/dynamic-content/dynamic-content-edit/dynamic-content-edit.component';
import { DynamicContentDetailComponent } from './pages/dynamic-content/dynamic-content-detail/dynamic-content-detail.component';
import { ImportDataExplorerComponent } from './pages/import-data-explorer/import-data-explorer.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { CustomersListComponent } from './pages/customers-list/customers-list.component';
import { ResetRedirectComponent } from './pages/authentication/reset/reset-redirect/reset-redirect.component';
import { DashboardMessageComponent } from './pages/dashboard-message/dashboard-message.component';
import { DashboardMessageEditComponent } from './pages/dashboard-message/dashboard-message-edit/dashboard-message-edit.component';
import { OrganisationCustomerComponent } from './pages/organisation-customer/organisation-customer.component';
import { OrganisationCustomerDetailComponent } from './pages/organisation-customer/organisation-customer-detail/organisation-customer-detail.component';
import { OrganisationCustomerEditComponent } from './pages/organisation-customer/organisation-customer-edit/organisation-customer-edit.component';
import { DynamicContentEntrancesComponent } from './pages/dynamic-content-entrances/dynamic-content-entrances.component';
import { OrphansComponent } from './pages/orphans/orphans.component';
import { UrlShortenerComponent } from './pages/url-shortener/url-shortener.component';
import { ReadmesComponent } from './pages/readmes/readmes.component';
import { ReadmesEditComponent } from './pages/readmes/readmes-edit/readmes-edit.component';
import { CleanUpQuillComponent } from './pages/clean-up-quill/clean-up-quill.component';
import { AnalyticsComponent } from './pages/analytics/analytics.component';
import { FailedPackagesDetailComponent } from './pages/failed-packages/failed-packages-detail/failed-packages-detail.component';
import { ExternalTokensComponent } from './pages/external-tokens/external-tokens.component';
import { ExternalTokensEditComponent } from './pages/external-tokens/external-tokens-edit/external-tokens-edit.component';
import { PipeImportsComponent } from './pages/pipe-imports/pipe-imports.component';
import { PipeImportEditComponent } from './pages/pipe-imports/pipe-import-edit/pipe-import-edit.component';
import { PipeImportDetailComponent } from './pages/pipe-imports/pipe-import-detail/pipe-import-detail.component';
import { PipeImportLogsComponent } from './pages/pipe-imports/pipe-import-logs/pipe-import-logs.component';
import { PipeImportLogsDetailComponent } from './pages/pipe-imports/pipe-import-logs/pipe-import-logs-detail/pipe-import-logs-detail.component';
import { FailedPipeImportsComponent } from './pages/failed-pipe-imports/failed-pipe-imports.component';
import { GroupSecuredAppManagerComponent } from './pages/groups/group-secured-app-manager/group-secured-app-manager.component';
import { BannerComponent } from './pages/banner/banner.component';
import { BannerEditComponent } from './pages/banner/banner-edit/banner-edit.component';
import { BannerDetailComponent } from './pages/banner/banner-detail/banner-detail.component';
import { MyOrganizationComponent } from './pages/my-organization/my-organization.component';
import { IbexiconComponent } from './pages/ibexicon/ibexicon.component';
import { TranslationComponent } from './pages/translation/translation.component';
import { TranslationEditComponent } from './pages/translation/translation-edit/translation-edit.component';
import { TranslationDetailComponent } from './pages/translation/translation-detail/translation-detail.component';
import { AnalyticsDetailComponent } from './pages/analytics/analytics-detail/analytics-detail.component';
import { CustomerWizardEditComponent } from './pages/customer-wizard/customer-wizard-edit/customer-wizard-edit.component';
import { CompositionImportsComponent } from './pages/compositions/composition-imports/composition-imports.component';
import { CleanupCustomerComponent } from './pages/cleanup-customer/cleanup-customer.component';
import { CleanupCustomerExecuteComponent } from './pages/cleanup-customer/execute/cleanup-customer-execute.component';
import { UserAdminComponent } from './pages/user-admin/user-admin.component';
import { UserAdminDetailComponent } from './pages/user-admin/user-admin-detail/user-admin-detail.component';
import { UserAdminEditComponent } from './pages/user-admin/user-admin-edit/user-admin-edit.component';
import { ContactAndAddressComponent } from './pages/contact-and-address/contact-and-address.component';
import { ContactAndAddressEditComponent } from './pages/contact-and-address/contact-and-address-edit/contact-and-address-edit.component';
import { PackageLegalComponent } from './pages/packages/package-legal/package-legal.component';
import { PackageScreenImagesComponent } from './pages/packages/package-screen-images/package-screen-images.component';
import { NavigationComponent } from './pages/navigation/navigation.component';
import { DriverComponent } from './pages/driver/driver.component';
import { DriverEditComponent } from './pages/driver/driver-edit/driver-edit.component';
import { ContentPoolComponent } from './pages/content-pool/content-pool.component';
import { ContentPoolDetailComponent } from './pages/content-pool/content-pool-detail/content-pool-detail.component';
import { ContentPoolEditComponent } from './pages/content-pool/content-pool-edit/content-pool-edit.component';
import { ChatsComponent } from './pages/chats/chats.component';
import { ChatsListComponent } from './pages/chats/chats-list/chats-list.component';

export const routes: Routes = [

  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { title: 'Dashboard', allowAll: true },
    canActivate: [AuthenticationGuard, OrganisationGuard]
  },
  {
    path: 'access',
    canActivate: [TokenGuard],
    component: ResetRedirectComponent
  },
  {
    path: 'auth',
    outlet: 'auth',
    component: AuthenticationComponent,
    children: [
      {
        path: 'login',
        outlet: 'authentication',
        component: LoginComponent
      },
      {
        path: 'register',
        outlet: 'authentication',
        component: RegisterComponent
      },
      {
        path: 'reset',
        outlet: 'authentication',
        component: ResetComponent,
        canActivate: [TokenGuard]
      },
      {
        path: 'message',
        outlet: 'authentication',
        component: MessageComponent
      }
    ]
  },
  {
    path: ':organisationName',
    outlet: 'org',
    component: OrganisationSelectorComponent,
    canActivate: [AuthenticationGuard, OrganisationGuard]
  },
  {
    path: 'selectOrganisation',
    component: SelectOrganisationComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'my-profile',
    component: MyProfileComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'my-organization',
    component: MyOrganizationComponent,
    canActivate: [AuthenticationGuard]
  },

  {
    path: 'errorlog',
    data: { title: 'API Error Logs', privileges: [{ name: 'read', value: 'errors' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard],
    children: [
      {
        path: '',
        component: ErrorlogComponent
      },
      {
        path: ':id',
        component: ErrorlogDetailComponent
      }
    ]
  },
  {
    path: 'frontend-errorlog',
    data: {
      title: 'Ibexfusion Error Logs',
      privileges: [{ name: 'read', value: 'frontend-error-logs' }],
      params: { frontendType: 'ng-ibexfusion' }
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: FrontendErrorlogComponent,
      },
      {
        path: 'ng-ibexfusion/:id',
        component: FrontendErrorlogDetailComponent,
      }
    ]
  },
  {
    path: 'frontend-errorlog/ibexsmart',
    data: {
      title: 'ibexsmart Error Logs',
      privileges: [{ name: 'read', value: 'frontend-error-logs' }],
      params: { frontendType: 'ibexsmart' }
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: FrontendErrorlogComponent
      },
      {
        path: ':id',
        component: FrontendErrorlogDetailComponent,
      }
    ]
  },
  {
    path: 'frontend-errorlog/ibextouch',
    data: {
      title: 'ibextouch Error Logs',
      privileges: [{ name: 'read', value: 'frontend-error-logs' }],
      params: { frontendType: 'ibextouch' }
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: FrontendErrorlogComponent
      },
      {
        path: ':id',
        component: FrontendErrorlogDetailComponent,
      }
    ]
  },
  {
    path: 'failed-imports',
    component: FailedImportsComponent,
    data: {
      title: 'Failed imports',
      messageBubble: {
        functionName: 'getPageCount()',
        service: 'ImportService',
        params: { wasLastSuccessful: false }
      },
      privileges: [{ name: 'read', value: 'failing-importers' }]
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
  },
  {
    path: 'failed-pipe-imports',
    component: FailedPipeImportsComponent,
    data: {
      title: 'Failed pipe imports',
      messageBubble: {
        functionName: 'getPageCount()',
        service: 'PipeImportService',
        params: { wasLastSuccessful: false }
      },
      privileges: [{ name: 'read', value: 'failing-pipe-imports' }]
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
  },
  {
    path: 'failed-packages',
    data: {
      title: 'Failed imports',
      messageBubble: {
        functionName: 'getPageCount()',
        service: 'PackageService',
        params: { $or: [{ 'cache.success': { $eq: false } }, { 'cache.successDynamicContent': false }, { 'cache.successScreenGenerator': false }] }
      },
      privileges: [{ name: 'read', value: 'failing-packages' }]
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: FailedPackagesComponent
      },
      {
        path: 'detail/:id',
        component: FailedPackagesDetailComponent,
      }
    ]
  },
  {
    path: 'url-shortener',
    component: UrlShortenerComponent,
    data: {
      title: 'Url Shortener',
      privileges: [{ name: 'write', value: 'short-urls' }]
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
  },
  {
    path: 'cleanup-customer',
    data: {
      title: 'Cleanup Customer',
      privileges: [{ name: 'write', value: 'cleanup-customer' }]
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: CleanupCustomerComponent
      },
      {
        path: ':id',
        component: CleanupCustomerExecuteComponent,
        canActivate: [PrivilegeGuard]
      }
    ]
  },
  {
    path: 'importer-monitor',
    component: ImporterMonitorComponent,
    data: {
      title: 'Importer monitoring',
      privileges: [{ name: 'read', value: 'failing-importers' }]
    },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
  },
  {
    path: 'screens',
    data: { privileges: [{ name: 'read', value: 'screens' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ScreenListComponent
      },
      {
        path: ':id',
        component: ScreenDetailComponent
      }
    ]
  },
  {
    path: 'screen-settings',
    data: { privileges: [{ name: 'read', value: 'legacy-screen-settings' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':id',
        children: [
          {
            path: '',
            component: ScreenSettingsComponent
          },
          {
            path: 'edit',
            component: ScreenSettingsEditComponent,
            data: { privileges: [{ name: 'write', value: 'legacy-screen-settings' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'import-types',
    data: { title: 'Imports', privileges: [{ name: 'read', value: 'import-types' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ImportTypesComponent
      },
      {
        path: 'create',
        component: ImportTypesCreateComponent,
        data: { privileges: [{ name: 'write', value: 'import-types' }] },
        canActivate: [PrivilegeGuard],
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: ImportTypesDetailComponent,
          },
          {
            path: 'edit',
            component: ImportTypesEditComponent,
            data: { privileges: [{ name: 'write', value: 'import-types' }] },
            canActivate: [PrivilegeGuard],
          }
        ]
      }
    ]
  },
  {
    path: 'imports',
    data: { privileges: [{ name: 'read', value: 'imports' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: 'create',
        data: { privileges: [{ name: 'write', value: 'imports' }] },
        canActivate: [PrivilegeGuard],
        children: [
          {
            path: ':type-id',
            component: ImportCreateComponent,
          }
        ]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: ImportsDetailComponent
          },
          {
            path: 'explore',
            component: ImportDataExplorerComponent,
            canActivate: [PrivilegeGuard]
          },
          {
            path: 'connection',
            component: ImportConnectionComponent,
            canActivate: [PrivilegeGuard]
          },
          {
            path: 'edit',
            component: ImportEditComponent,
            data: { privileges: [{ name: 'write', value: 'imports' }] },
            canActivate: [PrivilegeGuard],
          }
        ]
      }
    ]
  },
  {
    path: 'import-logs', // displays all Logs, not in use
    data: { privileges: [{ name: 'read', value: 'import-logs' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ImportLogsComponent
      },
      {
        path: ':id',
        component: ImportLogsDetailComponent
      },
      {
        path: ':filter',
        children: [
          {
            path: ':id',
            component: ImportLogsComponent
          }
        ]
      }
    ]
  },
  {
    path: 'package-logs',
    children: [
      {
        path: ':id',
        component: ImportLogsDetailComponent,
        data: {
          type: 'package'
        }
      }
    ]
  },
  {
    path: 'pipe-imports',
    data: { title: 'Pipe Imports', privileges: [{ name: 'superadmin', value: 'pipe-imports' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: PipeImportsComponent
      },
      {
        path: 'create',
        component: PipeImportEditComponent,
        data: { privileges: [{ name: 'superadmin', value: 'pipe-imports' }] },
        canActivate: [PrivilegeGuard],
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: PipeImportDetailComponent,
          },
          {
            path: 'logs',
            children: [
              {
                path: '',
                component: PipeImportLogsComponent,
              },
              {
                path: ':logId',
                component: PipeImportLogsDetailComponent,
              }
            ]
          },
          {
            path: 'edit',
            component: PipeImportEditComponent,
            data: { privileges: [{ name: 'write', value: 'import-types' }] },
            canActivate: [PrivilegeGuard],
          }
        ]
      }
    ]
  },
  {
    path: 'code-snippets',
    data: { title: 'Code Snippets', privileges: [{ name: 'read', value: 'code-snippets' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: CodeSnippetsComponent
      },
      {
        path: 'create',
        component: CodeSnippetsEditComponent,
        data: { privileges: [{ name: 'write', value: 'code-snippets' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: CodeSnippetsDetailComponent
          },
          {
            path: 'edit',
            component: CodeSnippetsEditComponent,
            data: { privileges: [{ name: 'write', value: 'code-snippets' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'jsons',
    data: { privileges: [{ name: 'read', value: 'fakeJSONs' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':uuid',
        component: JsonEditComponent,
      },
      {
        path: ':id',
        children: [
          {
            path: 'detail',
            component: JsonReadOnlyComponent
          },
          {
            path: 'edit',
            component: JsonEditComponent,
            data: { privileges: [{ name: 'write', value: 'fakeJSONs' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },

  {
    path: 'packages',
    data: { title: 'Packages', privileges: [{ name: 'read', value: 'package-list' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: PackageListComponent
      },
      {
        path: 'create',
        data: { privileges: [{ name: 'write', value: 'packages' }] },
        canActivate: [PrivilegeGuard],
        children: [
          {
            path: '',
            component: PackageEditorComponent
          }
        ]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: PackagesComponent
          }
        ]
      }
    ]
  },
  {
    path: 'ibexicon',
    data: { title: 'Ibexicon', privileges: [{ name: 'read', value: 'ibexicon' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: IbexiconComponent
      }
    ]
  },
  {
    path: 'translation',
    data: { title: 'Translation', privileges: [{ name: 'write', value: 'translation' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: TranslationComponent
      },
      {
        path: 'create',
        component: TranslationEditComponent,
        data: { privileges: [{ name: 'write', value: 'translation' }] },
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: TranslationDetailComponent
          },
          {
            path: 'edit',
            component: TranslationEditComponent,
            data: { privileges: [{ name: 'write', value: 'translation' }] }
          }
        ]
      }
    ]
  },
  {
    path: 'banner',
    data: { title: 'Banners', privileges: [{ name: 'read', value: 'banners' }] },
    children: [
      {
        path: '',
        component: BannerComponent
      },
      {
        path: 'create',
        component: BannerEditComponent,
        data: { privileges: [{ name: 'write', value: 'banners' }] },
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: BannerDetailComponent
          },
          {
            path: 'edit',
            component: BannerEditComponent,
            data: { privileges: [{ name: 'write', value: 'banners' }] }
          }
        ]
      }
    ]
  },
  {
    path: 'driver',
    data: { title: 'Dirver Routes', privileges: [{ name: 'read', value: 'driver-routes' }] },
    children: [
      {
        path: '',
        component: DriverComponent
      },
      {
        path: 'create',
        component: DriverEditComponent,
        data: { privileges: [{ name: 'write', value: 'driver-routes' }] },
      },
      {
        path: ':id',
        children: [
          {
            path: 'edit',
            component: DriverEditComponent,
            data: { privileges: [{ name: 'write', value: 'driver-routes' }] }
          }
        ]
      }
    ]
  },
  {
    path: 'customers',
    data: { title: 'Customers', privileges: [{ name: 'read', value: 'customers' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: CustomersComponent
      },
      {
        path: 'create',
        component: CustomerEditComponent,
        data: { privileges: [{ name: 'write', value: 'customers' }] },
        canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: CustomerDetailComponent
          },
          {
            path: 'edit',
            component: CustomerEditComponent,
            data: { privileges: [{ name: 'write', value: 'customers' }] },
            canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'organisation-customers',
    data: { title: 'Organisation Customers', privileges: [{ name: 'read', value: 'organisation-customers' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: OrganisationCustomerComponent
      },
      {
        path: 'create',
        component: OrganisationCustomerEditComponent,
        data: { privileges: [{ name: 'write', value: 'organisation-customers' }] },
        canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: OrganisationCustomerDetailComponent
          },
          {
            path: 'edit',
            component: OrganisationCustomerEditComponent,
            data: { privileges: [{ name: 'write', value: 'organisation-customers' }] },
            canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'legacy-compositions',
    data: { title: 'Legacy Compositions', privileges: [{ name: 'read', value: 'legacy-compositions' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: LegacyCompositionComponent
      },
      {
        path: 'create',
        component: LegacyCompositionEditComponent,
        data: { privileges: [{ name: 'write', value: 'legacy-compositions' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: LegacyCompositionDetailComponent
          },
          {
            path: 'edit',
            component: LegacyCompositionEditComponent,
            data: { privileges: [{ name: 'write', value: 'legacy-compositions' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'customers-list',
    data: { title: 'Customers List', privileges: [{ name: 'read', value: 'customers-list' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: CustomersListComponent
      },
    ]
  },
  {
    path: 'composition-types',
    data: { title: 'Compositions', privileges: [{ name: 'read', value: 'composition-types' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [{ path: '', component: CompositionsComponent }]
  },
  {
    path: 'compositions',
    data: { privileges: [{ name: 'read', value: 'compositions' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: 'create/:typeId',
        component: CompositionWizardComponent,
        data: { privileges: [{ name: 'write', value: 'compositions' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: CompositionDetailComponent
          },
          {
            path: 'edit',
            component: CompositionWizardComponent,
            data: { privileges: [{ name: 'write', value: 'compositions' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: 'copy',
            component: CompositionWizardComponent,
            data: { privileges: [{ name: 'write', value: 'compositions' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: 'imports',
            component: CompositionImportsComponent,
            data: { privileges: [{ name: 'write', value: 'compositions' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: 'apps',
            data: { privileges: [{ name: 'read', value: 'composition-apps' }] },
            canActivate: [PrivilegeGuard],
            children: [
              {
                path: '',
                component: CompositionAppEditorComponent
              },
              {
                path: 'create',
                component: CompositionAppEditorComponent,
                data: { privileges: [{ name: 'write', value: 'composition-apps' }] },
                canActivate: [PrivilegeGuard]
              },
              {
                path: ':appId',
                children: [
                  {
                    path: '',
                    component: CompositionAppDetailComponent
                  },
                  {
                    path: 'edit',
                    component: CompositionAppEditorComponent,
                    data: { privileges: [{ name: 'write', value: 'composition-apps' }] },
                    canActivate: [PrivilegeGuard]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'orphans',
    data: { title: 'Orphans', privileges: [{ name: 'read', value: 'orphans' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: OrphansComponent
      }
    ]
  },
  {
    path: 'organisations',
    data: { title: 'Organisations', privileges: [{ name: 'read', value: 'organisations' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: OrganisationsComponent
      },
      {
        path: 'create',
        component: OrganisationEditComponent,
        data: { privileges: [{ name: 'write', value: 'organisations' }] },
        canActivate: [PrivilegeGuard],
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: OrganisationDetailComponent
          },
          {
            path: 'edit',
            component: OrganisationEditComponent,
            data: { privileges: [{ name: 'write', value: 'organisations' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'groups',
    data: { title: 'Groups', privileges: [{ name: 'read', value: 'groups' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: GroupsComponent
      },
      {
        path: 'create',
        component: GroupEditComponent,
        data: { privileges: [{ name: 'write', value: 'groups' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: GroupDetailComponent
          },
          {
            path: 'edit',
            component: GroupEditComponent
          },
          {
            path: 'roles',
            component: GroupRolesManagerComponent
          },
          {
            path: 'participants',
            component: GroupParticipantsManagerComponent
          },
          {
            path: 'has-content',
            component: GroupContentManagerComponent
          },
          {
            path: 'has-secured-app',
            component: GroupSecuredAppManagerComponent
          },
        ]
      }
    ]
  },
  {
    path: 'privileges',
    data: { title: 'Privileges', privileges: [{ name: 'read', value: 'privileges' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: PrivilegesComponent
      },
      {
        path: 'create',
        component: PrivilegeEditComponent,
        data: { privileges: [{ name: 'write', value: 'privileges' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id/edit',
        component: PrivilegeEditComponent,
        data: { privileges: [{ name: 'write', value: 'privileges' }] },
        canActivate: [PrivilegeGuard]
      }
    ]
  },
  {
    path: 'roles',
    data: { title: 'Roles', privileges: [{ name: 'read', value: 'roles' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: RolesComponent
      },
      {
        path: 'create',
        component: RoleEditComponent,
        data: { privileges: [{ name: 'write', value: 'roles' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: RoleDetailComponent
          },
          {
            path: 'edit',
            component: RoleEditComponent,
            data: { privileges: [{ name: 'write', value: 'roles' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'profiles',
    data: { title: 'Profiles', privileges: [{ name: 'read', value: 'profiles' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ProfilesComponent
      },
      {
        path: 'create',
        component: ProfileEditComponent,
        data: { privileges: [{ name: 'write', value: 'profiles' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: ProfileDetailComponent
          },
          {
            path: 'edit',
            component: ProfileEditComponent,
            data: { privileges: [{ name: 'write', value: 'profiles' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'external-tokens',
    data: { title: 'External Tokens', privileges: [{ name: 'read', value: 'external-tokens' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ExternalTokensComponent
      },
      {
        path: 'create',
        component: ExternalTokensEditComponent,
        data: { privileges: [{ name: 'write', value: 'external-tokens' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: 'edit',
            component: ExternalTokensEditComponent,
            data: { privileges: [{ name: 'write', value: 'profiles' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'dashboard-messages',
    data: { title: 'Dashboard Messages', privileges: [{ name: 'write', value: 'dashboard-messages' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: DashboardMessageComponent
      },
      {
        path: 'create',
        canActivate: [PrivilegeGuard],
        data: { privileges: [{ name: 'write', value: 'dashboard-messages' }] },
        component: DashboardMessageEditComponent
      },
      {
        path: ':id',
        data: { privileges: [{ name: 'write', value: 'dashboard-messages' }] },
        canActivate: [PrivilegeGuard],
        component: DashboardMessageEditComponent
      }
    ]
  },
  {
    path: 'readmes',
    data: { title: 'Markdown readmes', privileges: [{ name: 'write', value: 'readmes' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ReadmesComponent
      },
      {
        path: 'create',
        canActivate: [PrivilegeGuard],
        data: { privileges: [{ name: 'write', value: 'readmes' }] },
        component: ReadmesEditComponent
      },
      {
        path: ':id',
        data: { privileges: [{ name: 'write', value: 'readmes' }] },
        canActivate: [PrivilegeGuard],
        component: ReadmesEditComponent
      }
    ]
  },
  {
    path: 'redirects',
    data: { title: 'Redirects', privileges: [{ name: 'read', value: 'redirects' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: RedirectsComponent
      },
      {
        path: 'create',
        component: RedirectEditComponent,
        data: { privileges: [{ name: 'write', value: 'redirects' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: 'create/:screenId',
        component: RedirectEditComponent,
        data: { privileges: [{ name: 'write', value: 'redirects' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: 'log',
        component: RedirectLogComponent,
        data: { privileges: [{ name: 'read', value: 'redirect-logs' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: 'log/:id',
        component: RedirectLogComponent,
        data: { privileges: [{ name: 'read', value: 'redirect-logs' }] },
        canActivate: [PrivilegeGuard]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: RedirectDetailComponent
          },
          {
            path: 'edit',
            component: RedirectEditComponent,
            data: { privileges: [{ name: 'write', value: 'redirects' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'kue',
    component: KueComponent,
    data: { title: 'Kue', privileges: [{ name: 'read', value: 'kue' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard]
  },
  {
    path: 'dynamic-content',
    data: { title: 'Dynamic Content', privileges: [{ name: 'read', value: 'dynamic-contents' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: DynamicContentEntrancesComponent
      },
      {
        path: ':packageId',
        component: DynamicContentComponent,
      },
      {
        path: ':type',
        children: [
          {
            path: '',
            component: DynamicContentComponent,
          },
          {
            path: 'create',
            component: DynamicContentEditComponent,
            data: { privileges: [{ name: 'write', value: 'dynamic-contents' }] },
            canActivate: [PrivilegeGuard],
            canDeactivate: [PendingChangesGuard]
          },
          {
            path: ':id',
            children: [
              {
                path: '',
                component: DynamicContentDetailComponent
              },
              {
                path: 'edit',
                component: DynamicContentEditComponent,
                data: { privileges: [{ name: 'write', value: 'dynamic-contents' }] },
                canActivate: [PrivilegeGuard],
                canDeactivate: [PendingChangesGuard]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'my-packages',
    data: { title: 'My Packages', privileges: [{ name: 'read', value: 'my-packages' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':id',
        children: [
          {
            path: '',
            component: PackagesComponent
          }
        ]
      }
    ]
  },
  {
    path: 'navigation',
    data: { title: 'Navigation', privileges: [{ name: 'read', value: 'my-packages' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':id',
        children: [
          {
            path: '',
            component: NavigationComponent
          }
        ]
      }
    ]
  },
  {
    path: 'legal',
    data: { title: 'Legal', privileges: [{ name: 'read', value: 'my-packages' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':id',
        component: PackageLegalComponent
      }
    ]
  },
  {
    path: 'images',
    data: { title: 'Images', privileges: [{ name: 'read', value: 'my-packages' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':id',
        component: PackageScreenImagesComponent
      }
    ]
  },
  {
    path: 'resources',
    data: { title: 'Resources', privileges: [{ name: 'read', value: 'assets' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ResourcesComponent
      },
      {
        path: ':packageId',
        children: [
          {
            path: 'media',
            component: ResourcesComponent,
          }
        ]
      },
    ]
  },
  {
    path: 'contact',
    data: {  title: 'contact', privileges: [{ name: 'read', value: 'assets' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ContactAndAddressComponent
      },
      {
        path: ':type',
        children: [
          {
            path: '',
            component: ContactAndAddressComponent
          },
          {
            path: 'create',
            component: ContactAndAddressEditComponent
          },
          {
            path: ':itemId',
            component: ContactAndAddressEditComponent
          }
        ]
      }
    ]
  },
  {
    path: 'my-users',
    data: { title: 'Users', privileges: [{ name: 'read', value: 'my-users' }], baseUrl: 'my-users' },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: ':packageId',
        children: [
          {
            path: '',
            component: UserAdminDetailComponent,
            data: { privileges: [{ name: 'write', value: 'my-users' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: ':type',
            component: UserAdminEditComponent,
            data: { privileges: [{ name: 'write', value: 'my-users' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: ':type/:itemId',
            component: UserAdminEditComponent,
            data: { privileges: [{ name: 'write', value: 'my-users' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'chats',
    data: { title: 'Chats', privileges: [{ name: 'write', value: 'chats' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ChatsComponent
      },
      {
        path: ':id',
        component: ChatsListComponent
      }
    ]
  },
  {
    path: 'user-admin',
    data: { title: 'User admin', privileges: [{ name: 'superadmin', value: 'user-admin' }], baseUrl: 'my-users' },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: UserAdminComponent
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: UserAdminDetailComponent,
            data: { privileges: [{ name: 'write', value: 'user-admin' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: ':type',
            component: UserAdminEditComponent,
            data: { privileges: [{ name: 'write', value: 'user-admin' }] },
            canActivate: [PrivilegeGuard]
          },
          {
            path: ':type/:itemId',
            component: UserAdminEditComponent,
            data: { privileges: [{ name: 'write', value: 'user-admin' }] },
            canActivate: [PrivilegeGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'content-pool',
    data: { title: 'Content Pool', privileges: [{name: 'write', value: 'content-pool' }], baseUrl: 'content-pool' },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: ContentPoolComponent
      },
      {
        path: ':type',
        component: ContentPoolDetailComponent,
      },
      {
        path: ':type/create',
        component: ContentPoolEditComponent
      },
      {
        path: ':type/:id',
        component: ContentPoolEditComponent
      }
    ]
  },
  {
    path: 'newCustomer',
    data: { title: 'New Customer', privileges: [{ name: 'write', value: 'new-customers' }], baseUrl: 'my-users' },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: CustomerWizardEditComponent
      },
      {
        path: 'create',
        component: CustomerWizardEditComponent,
        data: { privileges: [{ name: 'write', value: 'packages' }] },
        canActivate: [PrivilegeGuard],
      },
      {
        path: ':id',
        children: [
          {
            path: 'edit',
            component: CustomerWizardEditComponent,
            data: { privileges: [{ name: 'write', value: 'packages' }] },
            canActivate: [PrivilegeGuard],
          }
        ]
      }
    ]
  },
  {
    path: 'analytics',
    data: { title: 'Analytics', privileges: [{ name: 'read', value: 'analytics' }] },
    canActivate: [AuthenticationGuard, OrganisationGuard, PrivilegeGuard],
    children: [
      {
        path: '',
        component: AnalyticsComponent
      },
      {
        path: 'ibex4/:organisationCustomerId',
        children: [
          {
            path: '',
            component: AnalyticsDetailComponent
          }
        ]
      },
      {
        path: 'ibex3/:ibexCustomerId',
        children: [
          {
            path: '',
            component: AnalyticsDetailComponent
          }
        ]
      }
    ]
  },
  { path: 'page-not-authenticated', component: PageNotAuthComponent },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {
}
